import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderPrayScriptureChildren from "../../../../src/content/how-to-pray-scripture-for-your-children/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderPrayScriptureChildren,
  React
};